import { render, staticRenderFns } from "./performance.vue?vue&type=template&id=49898a9a&scoped=true"
import script from "./performance.vue?vue&type=script&lang=js"
export * from "./performance.vue?vue&type=script&lang=js"
import style0 from "./performance.vue?vue&type=style&index=0&id=49898a9a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49898a9a",
  null
  
)

export default component.exports